import { render, staticRenderFns } from "./LabelDetail.vue?vue&type=template&id=25d44cca"
import script from "./LabelDetail.vue?vue&type=script&lang=js"
export * from "./LabelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d44cca')) {
      api.createRecord('25d44cca', component.options)
    } else {
      api.reload('25d44cca', component.options)
    }
    module.hot.accept("./LabelDetail.vue?vue&type=template&id=25d44cca", function () {
      api.rerender('25d44cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LabelDetail.vue"
export default component.exports